import { render, staticRenderFns } from "./CouponManagmentDashboard.vue?vue&type=template&id=2551e0c5&scoped=true"
import script from "./CouponManagmentDashboard.vue?vue&type=script&lang=js"
export * from "./CouponManagmentDashboard.vue?vue&type=script&lang=js"
import style0 from "./CouponManagmentDashboard.vue?vue&type=style&index=0&id=2551e0c5&prod&scoped=true&lang=css"
import style1 from "./CouponManagmentDashboard.vue?vue&type=style&index=1&id=2551e0c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2551e0c5",
  null
  
)

export default component.exports